import {Component} from '@angular/core';
import {CoreApiService} from "../core/core-api-service";
import {DatePipe, NgForOf, NgIf} from "@angular/common";
import {SecondsToTimeFormatPipe} from "../seconds-to-time-format-pipe";
import {NgbActiveModal, NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {TranslationTrackingService} from "../translation/translation-tracking.service";
import {CheckboxComponent} from "../CheckBox/checkbox.component";
import {FormsModule} from "@angular/forms";
import {TrackTranslatePipe} from "../translation/track-translate.pipe";
import {TranslationComponent} from "../../Main/Administration/Translation/translation.component";

@Component({
    imports: [
        NgForOf,
        DatePipe,
        SecondsToTimeFormatPipe,
        NgIf,
        CheckboxComponent,
        TrackTranslatePipe,
        FormsModule,
        TranslationComponent
    ],
    templateUrl: './system-health-modal.component.html',
    styleUrl: './system-health-modal.component.css'
})
export class SystemHealthModalComponent {
    constructor(
        protected core: CoreApiService,
        protected activeModal: NgbActiveModal,
        protected trackingService: TranslationTrackingService) {
        trackingService.loadAllKeys();
    }

    activeTab: 'requests' | 'missingTranslations' | 'translate' = 'requests';

    setActiveTab(tab: 'requests' | 'missingTranslations' | 'translate'): void {
        this.activeTab = tab;
    }

    clearHistory(): void {
        this.core.requestHistory = [];
    }

    public static Open(modalService: NgbModal) {
        return modalService.open(SystemHealthModalComponent, {
            size: 'xl',
            backdrop: 'static'
        });
    }
}
